export default {
    filterOption: {
        selectedMonth: '',
    },
    hubInfo: {},
    withholdTaxInfo: {},
};
